import MyResume from "../../components/MyResume";
import PageHeader from "../../components/PageHeader";
import SocialIcons from "../../components/SocialIcons";

const Resume = ({ name, location, brand, email, availability }) => {
    return (
        <section className="resume">
            <PageHeader title="Resume" description="Coming Soon..." />
            <MyResume name={name} location={location} brand={brand} email={email} availability={availability} />
            <SocialIcons />
        </section>
    );
};

export default Resume;